import { render, staticRenderFns } from "./androidRedirect.vue?vue&type=template&id=0a86c68e&"
import script from "./androidRedirect.vue?vue&type=script&lang=js&"
export * from "./androidRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports